var React = require('react');

function ArrowBold (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.5872 17.7042L18.2858 5.41179L19.6986 4L32 16.2924L30.5872 17.7042Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31.9037 16.4135L20.3854 28L18.9726 26.5882L30.4909 15.0017L31.9037 16.4135Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M30.9804 17.1979L0 17.1979V15.2014L29.4921 15.2014L30.9804 16.356V17.1979Z","fill":"currentColor","key":2})]);
}

ArrowBold.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowBold;

ArrowBold.default = ArrowBold;
